import Pusher from 'pusher-js';

let pusherInstance = null;

export const getPusher = () => {
  if (!pusherInstance) {
    pusherInstance = new Pusher(import.meta.env.VITE_PUSHER_KEY, {
      cluster: import.meta.env.VITE_PUSHER_CLUSTER,
      forceTLS: true
    });
  }
  return pusherInstance;
};
